export default [
  {
    path: "/catalogue/assemblies/",
    name: "assemblies-library",
    component: () => import("@/features/assemblies/pages/AssembliesLibraryPage.vue"),
    meta: {
      layout: "app",
      group: "Catalogue",
      title: "Assemblies",
      breadcrumbs: [
        { name: "Programmes", route: "project-list" },
        { name: "Assemblies", route: "assemblies-library" },
      ],
    },
  },
];